const allowedPaths = ['/equipment/'];

const isAllowedPath = (currentPath: string) => {
  return allowedPaths.some((allowedPath) => {
    const normalizePath = currentPath.split('?')[0];
    return normalizePath.includes(allowedPath);
  });
};

export const getCurrentPath = (
  pathname: string,
  searchParams: URLSearchParams
): string => {
  const paramString = searchParams.toString();
  return paramString.length > 0 ? `${pathname}?${paramString}` : pathname;
};

export const getModifiedLogoutURL = (
  logoutURL: string,
  currentPath: string
) => {
  if (!isAllowedPath(currentPath)) {
    return logoutURL;
  }

  const [pathname, queryString] = logoutURL.split('?');
  const logoutUrlParams = new URLSearchParams(queryString || '');

  const searchParams = new URLSearchParams({
    URL: currentPath,
    physicalStoreId: logoutUrlParams.get('physicalStoreId'),
    storeId: logoutUrlParams.get('storeId')
  });

  return `${pathname}?${searchParams.toString()}`;
};
